import { authedApiInstance } from '../firebase';
import { GetVibesResponse } from '../definitions/vibes';

export const getVibes = () =>
  authedApiInstance
    .get<GetVibesResponse>('/vibes')
    .then((response) => response.data)
    .catch((error) => error?.response?.data);
